<template>
  <!-- Layout con .page-container per coerenza con altre pagine -->
  <main id="create-client-page" class="page-container">
    <!-- Messaggi di errore e successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- Form principale -->
    <form class="create-client-form" @submit.prevent="onUpdateClient">
      <!-- RIGA 1: Nome Cliente, Codice fiscale, Telefono, PEC -->
      <div class="create-client-row row-1">
        <div class="field">
          <label for="client-name">Nome cliente</label>
          <input
            id="client-name"
            type="text"
            v-model="formData.clientName"
            placeholder="inserisci"
          />
        </div>
        <!-- Codice fiscale -->
        <div class="field">
          <label for="fiscal-code">Codice fiscale</label>
          <input
            id="fiscal-code"
            type="text"
            v-model="formData.taxCode"
            placeholder="inserisci il codice fiscale..."
          />
        </div>
      </div>
      <div class="create-client-row row-2">
        <!-- Telefono -->
        <div class="field">
          <label for="phone">Telefono</label>
          <input
            id="phone"
            type="text"
            v-model="formData.phoneNumber"
            placeholder="inserisci il numero di telefono..."
          />
        </div>
        <!-- PEC -->
        <div v-if="formData.pec" class="field">
          <label for="pec">Pec</label>
          <input
            id="pec"
            type="email"
            v-model="formData.pec"
            placeholder="inserisci l'indirizzo pec..."
          />
        </div>
        <div v-if="formData.email" class="field">
          <label for="email">Email</label>
          <input
            id="email"
            type="email"
            v-model="formData.email"
            placeholder="inserisci l'indirizzo pec..."
          />
        </div>
      </div>

      <hr />

      <!-- RIGA 2: Ragione Sociale, P.IVA, Codice univoco, Sede Legale -->
      <div class="create-client-row row-2">
        <!-- Ragione Sociale -->
        <div class="field">
          <label for="business-name">Ragione sociale</label>
          <input
            id="business-name"
            type="text"
            v-model="formData.companyName"
            placeholder="inserisci"
            required
          />
        </div>
        <!-- Partita IVA -->
        <div class="field">
          <label for="vat-number">P.IVA</label>
          <input
            id="vat-number"
            type="text"
            v-model="formData.vatNumber"
            placeholder="inserisci"
          />
        </div>

        <!-- Sede Legale -->
        <div class="field">
          <label for="lh-address">Sede legale</label>
          <input
            type="text"
            v-model="formData.legalHeadquarters.address"
            placeholder="inserisci l'indirizzo della sede legale..."
            class="address-input"
          />
        </div>

        <!-- Bottone Salva allineato a destra -->
        <div class="save-button-container">
          <button
            id="create-client-button"
            type="submit"
            :disabled="!canSave"
            :title="
              !canSave ? 'Modifica almeno uno dei campi' : 'Aggiorna cliente'
            "
          >
            Aggiorna
          </button>
        </div>
      </div>
    </form>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
// accetta sia stringa JSON che oggetto
const asLoc = (raw) => {
  if (!raw) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw;
};

export default {
  name: "EditClientPage",
  props: ["clientId"],
  computed: {
    canSave() {
      return this.computeSignature() !== this.originalSig;
    },
  },
  data() {
    return {
      formData: {
        clientName: "",
        taxCode: "",
        phoneNumber: "",
        uniqueCode: "",
        companyName: "",
        vatNumber: "",
        email: "",
        pec: "",
        legalHeadquarters: {
          name: "",
          address: "",
        },
      },
      originalSig: "",

      errorMessage: "",
      successMessage: "",
    };
  },
  methods: {
    ...mapActions(["updateClient"]),

    normalizeForCompare() {
      const f = this.formData || {};
      const H = f.legalHeadquarters || {};

      return {
        clientName: f.clientName || "",
        taxCode: f.taxCode || "",
        phoneNumber: f.phoneNumber || "",
        uniqueCode: f.uniqueCode || "",
        companyName: f.companyName || "",
        vatNumber: f.vatNumber || "",
        pec: f.pec || "",
        email: f.email || "",
        legalHeadquarters: (H.address || "").trim() || null,
      };
    },
    computeSignature() {
      return JSON.stringify(this.normalizeForCompare());
    },
    captureSnapshot() {
      this.originalSig = this.computeSignature();
    },

    /**
     * Recupera i dati dell'cliente da modificare.
     * Viene chiamato appena il componente è montato.
     */
    async fetchClientData() {
      try {
        this.errorMessage = "";
        const response = await this.$axios.get(`client/${this.clientId}`);
        // console.log("client data response: ", response);
        // Adatta il percorso a seconda della tua API
        if (response.status === 200) {
          // Popola i campi con i dati ottenuti
          const clientData = response.data.client;
          this.formData.clientName = clientData.clientName;
          this.formData.taxCode = clientData.taxCode;
          this.formData.phoneNumber = clientData.phoneNumber;
          this.formData.uniqueCode = clientData.uniqueCode;
          this.formData.companyName = clientData.companyName;
          this.formData.vatNumber = clientData.vatNumber;
          this.formData.pec = clientData.pec;
          this.formData.email = clientData.email;
          const rawLh = asLoc(clientData.legalHeadquarters);
          this.formData.legalHeadquarters = {
            name: rawLh?.name || "",
            address: rawLh?.address || rawLh?.formatted_address || "",
          };

          this.$nextTick(() => {
            this.successMessage = `Dati del cliente con ID:${this.clientId} caricati con successo`;
            this.$toast.success(this.successMessage);
            this.captureSnapshot(); // stato iniziale caricato
          });
        }
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message ||
          "Impossibile caricare i dati del cliente.";
        this.$toast.error(this.errorMessage);
      }
    },

    async onUpdateClient() {
      try {
        this.errorMessage = "";
        this.successMessage = "";

        if (!(this.formData.legalHeadquarters?.address || "").trim()) {
          this.$toast.error("Inserisci l'indirizzo della sede legale.");
          return;
        }
        // Puoi usare un FormData se devi inviare anche file (immagine),
        // altrimenti un JSON semplice se l'API lo consente.
        const payload = {
          clientName: this.formData.clientName,
          taxCode: this.formData.taxCode,
          phoneNumber: this.formData.phoneNumber,
          uniqueCode: this.formData.uniqueCode,
          companyName: this.formData.companyName,
          vatNumber: this.formData.vatNumber,
          email: this.formData.email,
          pec: this.formData.pec,
          legalHeadquarters: this.formData.legalHeadquarters,
        };

        // Esempio di richiesta PATCH
        const response = await this.updateClient({
          clientId: this.clientId,
          payload,
        });

        if (response.status === 200) {
          await this.$store.dispatch("fetchClients");

          this.successMessage =
            response.data?.message || "Cliente aggiornato con successo!";
          this.$toast.success(this.successMessage);

          // redirect alla pagina clients
          setTimeout(() => {
            this.$router.push({ name: "customers" });
          }, 1000);
        }
      } catch (error) {
        // Se arrivi qui, c’è un errore => error.response esiste
        if (error.response?.status === 409) {
          // Gestisci il conflitto
          this.errorMessage =
            error.response.data?.message ||
            error.response.data?.details ||
            "Conflitto nei dati: esiste già un cliente con la stessa email e lo stesso telefono.";
          this.$toast.error(this.errorMessage);
        } else {
          this.errorMessage =
            error.response?.data?.details ||
            error.response?.data?.error ||
            "Errore durante l'aggiornamento del cliente.";
          this.$toast.error(this.errorMessage);
        }
        this.successMessage = "";
      }
    },
  },
  mounted() {
    this.fetchClientData();
  },
};
</script>

<style src="@/css/CreateClientPage.css"></style>
